// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1yJgr","actions":"GroupTable_actions__1WcA-","deleteModalFooter":"GroupTable_deleteModalFooter__2HL7x"};